import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    request: { type: Boolean, default: false },
    revoke: { type: Boolean, default: false },
  };

  connect() {
    if (this.requestValue === true) {
      this.requestPushNotificationsToken();
    } else if (this.revokeValue === true) {
      this.revokePushNotificationsToken();
    }
  }

  requestPushNotificationsToken() {
    try {
      if (typeof androidApp !== "undefined") {
        androidApp.requestPushNotificationsToken();
      } else if (typeof webkit !== "undefined" && typeof webkit.messageHandlers !== "undefined") {
        webkit.messageHandlers.requestPushNotificationsToken.postMessage(true);
      }
    } catch (error) {
      console.error("PushNotificationsController#requestPushNotificationsToken", error);
    }
  }

  revokePushNotificationsToken() {
    try {
      if (typeof androidApp !== "undefined") {
        androidApp.revokePushNotificationsToken();
      } else if (typeof webkit !== "undefined" && typeof webkit.messageHandlers !== "undefined") {
        webkit.messageHandlers.revokePushNotificationsToken.postMessage(true);
      }
    } catch (error) {
      console.error("PushNotificationsController#revokePushNotificationsToken", error);
    }
  }
}
